import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  keepaImg: {
    width: "100%",
    margin: "0px 0px",
    maxWidth: "100%",
    padding: "0px",
    height: "100%",
    aspectRatio: 5 / 2,
    objectFit: "fill",
  },
});
